import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import * as page from '../../pages/pages';
import { InAppBrowser } from '@ionic-native/in-app-browser';
@Component({
	selector: 'page-home',
	templateUrl: 'home.html'
})
export class HomePage {

	homeMenu: Array<{ title: string, icon: string, pageName: string, component: any;}>;
	menuDisplay: any;

	constructor(
		public navCtrl: NavController,
		private iab: InAppBrowser) {
	}

	ionViewDidLoad() {
		this.menuDisplay = [
			{title: 'Login', icon:'sign-in', pageName:'login', component: page.LoginPage},
			{ title: 'eCom Conference 2020', icon: 'users', pageName: 'conference', component: page.ConferencePage},
			{ title: 'Case Studies', icon: 'tasks', pageName: 'topics', component: page.TopicsPage},
			//{ title: 'Recent Videos', icon: 'video-camera', pageName: 'video',  component: page.VideoPage},	
			{ title: 'eCom Scotland eBooks', icon: 'book', pageName: 'ebooks',  component: page.EbooksPage},	
			// { title: 'Free eBook', icon: 'book', pageName: 'ebook',  component: page.EbookPage},
			{ title: 'Visit Website', icon: 'info-circle', pageName: 'ecom-site',  component: null},
		];
	}

	goToPage(tile) {
		if (tile.pageName == "topics") {
			this.navCtrl.push(tile.component, tile.pageName);
		} else if (tile.pageName == "ecom-site"){
			this.iab.create("http://ecomscotland.com/", '_system');
		}else{
			this.navCtrl.push(tile.component);
		}
	}

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts